import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from 'react-query';
import {
  createAccountInForecastPayable,
  createForecastPayable,
  deleteForecastPayable,
  detailForecastPayable,
  listForecastPayable,
  updateForecastPayable,
} from './ForecastPayable.service';
import {
  ForecastPayableCreateRequest,
  ForecastPayableGenerateAccountRequest,
  ForecastPayableUpdateRequest,
  ListForecastPayableQuery,
} from './ForecastPayable.types';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import { useServiceError } from '@/hooks';
import { notification } from 'antd';

export function useForecastPayableList(params?: ListForecastPayableQuery) {
  const query = useInfiniteQuery(
    ['forecast-payable', { ...params }],
    ({ pageParam }) => {
      const req: ListForecastPayableQuery = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listForecastPayable(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );

  useServiceError(query.error);

  return query;
}

export function useForecastPayableCreate() {
  const mutation = useMutation(
    (obj: ForecastPayableCreateRequest) => createForecastPayable(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso',
          description: 'Previsão criada com sucesso!',
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useForecastPayable(id: number) {
  const query = useQuery(['forecast-payable-detail', id], () =>
    detailForecastPayable(id),
  );

  useServiceError(query.error);

  return query;
}

export function useForecastPayableUpdate() {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (obj: ForecastPayableUpdateRequest) => updateForecastPayable(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso',
          description: 'Previsão alterada com sucesso!',
        });

        queryClient.invalidateQueries(['forecast-payable-detail']);
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useForecastPayableDelete() {
  const queryClient = useQueryClient();

  const mutation = useMutation((id: number) => deleteForecastPayable(id), {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Previsão excluída com sucesso!',
      });

      queryClient.invalidateQueries(['forecast-payable']);
    },
  });

  useServiceError(mutation.error);

  return mutation;
}

export function useForecastPayableCreateAccountPayable() {
  const mutation = useMutation(
    (obj: ForecastPayableGenerateAccountRequest) =>
      createAccountInForecastPayable(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Sucesso',
          description: 'Contas a pagar gerada com sucesso!',
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}
